import { render, staticRenderFns } from "./TutorialVideos.vue?vue&type=template&id=1f6ad20a&scoped=true&lang=pug&"
import script from "./TutorialVideos.vue?vue&type=script&lang=js&"
export * from "./TutorialVideos.vue?vue&type=script&lang=js&"
import style0 from "./TutorialVideos.vue?vue&type=style&index=0&id=1f6ad20a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6ad20a",
  null
  
)

export default component.exports